import React from "react";
import { Empty, List, Typography } from "antd";
import { QrCodeScanLog } from "types/qrCodeTypes";
import dayjs from 'dayjs';
import { DATE_TIME_AM_PM_FORMAT } from "constants/dates";
import { useTranslation } from "react-i18next";

interface QrCodeTabProps {
    qrCodeScanLogs: QrCodeScanLog[];
}

const QrCodeTab: React.FC<QrCodeTabProps> = ({ qrCodeScanLogs }) => {
    const { t } = useTranslation();
    return (
        <List
            header={<Typography.Text>{t('visitors.profile.qrCode.title')}</Typography.Text>}
            bordered
            dataSource={qrCodeScanLogs}
            locale={{
                emptyText: <Empty description={t('visitors.profile.qrCode.noData')} />
            }}
            renderItem={(item) => (
                <List.Item>
                    <Typography.Text>
                        {dayjs.utc(item.scannedUtc).local().format(DATE_TIME_AM_PM_FORMAT)}
                    </Typography.Text>
                    <Typography.Text>{item.source}</Typography.Text>
                </List.Item>
            )}
        />
    );
};

export default QrCodeTab;
